import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-success-animated-load',
  templateUrl: './success-animated-load.component.html',
  styleUrls: ['./success-animated-load.component.scss']
})
export class SuccessAnimatedLoadComponent implements OnInit, OnChanges {

  @Input() config;

  DEFAULT_CONFIG = {
    theme: '1',
    shrink: false
  };

  constructor() { }

  ngOnInit(): void {
    this.config = { ...this.DEFAULT_CONFIG, ...this.config };
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes?.config?.currentValue) {
      this.config = { ...this.DEFAULT_CONFIG, ...changes?.config?.previousValue, ...changes?.config?.currentValue };
    }
  }

}
